import React, { useContext, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
} from "@mui/material"; 
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "AuthContextWrapper"
import { OUTCOMES } from "../../../constants";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FileCabinetScreen } from "views/fileCabinet/FileCabinetScreen";
import { DOC_TYPE_ID_DRIVERS_LICENSE, DOC_TYPE_ID_MILITARY_ID, DOC_TYPE_ID_PASSPORT, DOC_TYPE_ID_TRIBAL_CARD } from "FileCabinetContextWrapper";
import { EXECUTOR_VERIFICATION_STEP_GOVT_ID_ID, EXECUTOR_VERIFICATION_SUBMITTED_ID } from ".";
import { ExecutorVerificationContext } from "ExecutorVerificationContextWrapper";

export const UploadGovernmentIDScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow } = useAuthContext() 
  const { verificationStepId, getStepStatusId, setStepStatusId, setVerificationStepId } = useContext(ExecutorVerificationContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

  useEffect(() => {
    setVerificationStepId(EXECUTOR_VERIFICATION_STEP_GOVT_ID_ID)
  }, [])

  const handleComplete = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");
    if (!verificationStepId) {
      console.warn("no step id--not loaded yet?")
      return false
    }

    setIsSubmitting(true)

    try {
      if(getStepStatusId(verificationStepId) !== EXECUTOR_VERIFICATION_SUBMITTED_ID) {
        await setStepStatusId(verificationStepId, EXECUTOR_VERIFICATION_SUBMITTED_ID)
      }
    }catch(error) {
      console.error("issue updating step, " + (error as any)?.message)
      setIsSubmitting(false)
      return false
    }
    
    setIsSubmitting(false)
    
    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  const handleBack = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    flow?.navigateToNext(currentScreen, OUTCOMES.back, navigate);
    return true;
  };

  if (!currentScreen) {
    return <></>;
  }

  return (
    <FlowScreenWrapper
      title="Please upload a picture of a government issued I.D."
      subTitle={
        "We know it’s going to be hard to choose between all your great pictures--think passport or driver’s license photo guidelines, clear and centered."
      }
    >
      <div style={{paddingTop:"3rem"}}>
        <FileCabinetScreen 
          header={<></>} 
          wrapContent={false} 
          includeOnlyDocumentTypeIds={[
            DOC_TYPE_ID_DRIVERS_LICENSE,
            DOC_TYPE_ID_MILITARY_ID,
            DOC_TYPE_ID_PASSPORT,
            DOC_TYPE_ID_TRIBAL_CARD,
          ]}  
        />
       
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            justifyContent: "space-between",
          }}
        >
          <Button
            color={"secondary"}
            variant="contained"
            disabled={isSubmitting}
            sx={{ minWidth: 180 }}
            onClick={async () => {
              setIsSubmitting(true);
              handleComplete();
              setIsSubmitting(false);
            }}
          >
            Continue
          </Button>
          <IconButton
            color={"secondary"}
            disabled={isSubmitting}
            aria-label="back"
            onClick={handleBack}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon color={"secondary"} />
          </IconButton>
        </Box>
      </div>
    </FlowScreenWrapper>
  );
};
